import { Fetcher } from "./fetcher";
import { ensureArray } from "./utils";

export const fetchDialers = (config = {}) => {
    const {
        apiPath,
        isSubSuperAdmin = false,
        moduleListingData = {},
        filterKey
    } = config;

    return Fetcher.get(`${apiPath}/api/obd/dialers/list`)
        .then(res => {
            let data = ensureArray(res);

            if (isSubSuperAdmin && filterKey) {
                const allowed = ensureArray(moduleListingData[filterKey]);
                data = data.filter(r => allowed.includes(r.dialerId));
            }

            return data;
        })
        .catch(err => {
            console.log('Error in fetching Dialer List', err);
            throw err;
        });
};

export const fetchDialersFast = (config = {}) => {
    const {
        apiPath,
        isSubSuperAdmin = false,
        moduleListingData = {},
        filterKey
    } = config;

    return Fetcher.get(`${apiPath}/api/obd/dialers`)
        .then(res => {
            let data = ensureArray(res);

            if (isSubSuperAdmin && filterKey) {
                const allowed = ensureArray(moduleListingData[filterKey]);
                data = data.filter(r => allowed.includes(r.dialerId));
            }

            return data;
        })
        .catch(err => {
            console.log('Error in fetching Dialer Fast List', err);
            throw err;
        });
};

export const fetchCli = (config = {}) => {
    const {
        apiPath,
        userId = '',
        cliType = 'cli',
        isSubSuperAdmin = false,
        moduleListingData = {},
        filterKey
    } = config;

    const endpoint =
        cliType === 'cli'
            ? '/api/obd/cli/'
            : '/api/obd/cli/dedicated/';

    return Fetcher.get(apiPath + endpoint + userId)
        .then(res => {
            let data = ensureArray(res);

            if (isSubSuperAdmin && filterKey) {
                const moduleData = moduleListingData[filterKey] || {};

                let allowed = [];
                if (cliType === 'cli') {
                    allowed = ensureArray(moduleData);
                }

                data = data.filter(r => allowed.includes(r.cliId));
            }

            return data;
        })
        .catch(err => {
            console.log('Error in fetching CLI List', err);
            throw err;
        });
};

export const fetchCliApi = (config = {}) => {
    const {
        apiPath,
        userId,
        isSubSuperAdmin = false,
        moduleListingData = {},
        filterKey } = config;

    return Fetcher.get(`${apiPath}/api/obd/cli/api/${userId}`)
        .then(res => {
            let data = ensureArray(res);

            if (isSubSuperAdmin && filterKey) {
                const allowed = ensureArray(moduleListingData[filterKey]);
                data = data.filter(r => allowed.includes(r.cliId));
            }

            return data;
        })
        .catch(err => {
            console.log('Error in fetching CLI API List', err);
            throw err;
        });
};

export const fetchGroups = (config = {}) => {
    const {
        apiPath,
        isSubSuperAdmin = false,
        moduleListingData = {},
        filterKey
    } = config;

    return Fetcher.get(`${apiPath}/api/obd/groups`)
        .then(res => {
            let data = ensureArray(res);

            if (isSubSuperAdmin && filterKey) {
                const allowed = ensureArray(moduleListingData[filterKey]);
                data = data.filter(r => allowed.includes(r.groupId));
            }

            return data;
        })
        .catch(err => {
            console.log('Error in fetching Group List', err);
            throw err;
        });
};

export const fetchLocations = (config = {}) => {
    const {
        apiPath,
        isSubSuperAdmin = false,
        moduleListingData = {},
        filterKey
    } = config;

    return Fetcher.get(`${apiPath}/api/obd/locations`)
        .then(res => {
            let data = ensureArray(res);

            if (isSubSuperAdmin && filterKey) {
                const allowed = ensureArray(moduleListingData[filterKey]);
                data = data.filter(r => allowed.includes(r.locationId));
            }

            return data;
        })
        .catch(err => {
            console.log('Error in fetching Location List', err);
            throw err;
        });
};